import { render, staticRenderFns } from "./AddAccountButton.vue?vue&type=template&id=4c61c8ae&scoped=true"
import script from "./AddAccountButton.vue?vue&type=script&lang=ts"
export * from "./AddAccountButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61c8ae",
  null
  
)

export default component.exports